import { createRoot } from "react-dom/client";

import { App } from "_/components/app";
import { Wrappers } from "_/components/wrappers";
import { initOtel } from "_/utils/otel";

function initReact() {
  const ROOT_ELEMENT = document.getElementById("app-root");

  if (ROOT_ELEMENT === null) {
    const error = [
      "Document root does not have a mount point. If you are seeing this error, ",
      "please email dev@aon3d.com and we will resolve the issue immediately. ",
      "This error should never occur.",
    ].join("");
    document.body.textContent = error;
  } else {
    const Root = () => {
      return (
        <Wrappers>
          <App />
        </Wrappers>
      );
    };

    const root = createRoot(ROOT_ELEMENT);
    root.render(<Root />);
  }
}

function main() {
  initOtel();
  initReact();
}

main();
